import moment from 'moment'
import 'moment/locale/es'
import {cuentaMask, dineroDisabledMask} from '../Components/Items'

moment.locale('es')

const reporteDeBalanzaDeComprobacionPdf = (values) => {
    const empresa = values.empresa
    let cuentasTable = values.arrayCuentas.map(valueIngresos => {
        return [
            {text: cuentaMask(valueIngresos.nivel1+valueIngresos.nivel2+valueIngresos.nivel3+valueIngresos.nivel4+valueIngresos.nivel5), alignment: 'left', style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico'},
            {text: valueIngresos.descripcion, alignment: 'left', style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico'},
            {text: dineroDisabledMask(valueIngresos.saldoInicial), alignment: 'right', style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico'},
            {text: dineroDisabledMask(valueIngresos.totalCargos), alignment: 'right', style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico'},
            {text: dineroDisabledMask(valueIngresos.totalAbonos), alignment: 'right', style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico'},
            {text: dineroDisabledMask(valueIngresos.saldoFinal), alignment: 'right', style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico'},
        ]
    })


    let filtrados = []

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: [ '18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80] 
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                  headerRows: 1,
                                  widths: ["100%"],
                
                                  body: [
                                    [
                                        { 
                                        text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno), 
                                        style: "tableHeader" 
                                        }
                                    ],
                                    [
                                      {
                                        text: "R.F.C: "+empresa.rfc,
                                        style: "textoChico",
                                        alignment: "center",
                                      },
                                    ],
                                    [
                                        {
                                          text: empresa.calle+' '+
                                          empresa.numeroCalle+' '+
                                          (empresa.numeroInterior ? empresa.numeroInterior : '')
                                          ,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                    [
                                        {
                                          text: empresa.colonia.tipoAsentamiento+' '+
                                          empresa.colonia.nombre+' C.P. '+
                                          empresa.colonia.cp+' '+
                                          empresa.municipio.nombre+' '+
                                          empresa.estado.abreviatura+' '+
                                          empresa.pais.abreviatura+' '
                                          ,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                  ],
                                },
                                layout: "noBorders",
                              },
                            {
                                border: [false, false, false, false],
                                    table: {
                                    headerRows: 1,
                                    widths: ['40%', '60%'],
                                
                                    body: [
                                        [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'left'},
                                        {text: moment(values.fechaInicial).locale('es').format('ll'), style: 'textoChico', alignment: 'left'}],
                                        [{text: 'Fecha Final:', style: 'subheader', alignment: 'left'},
                                        {text: moment(values.fechaFinal).locale('es').format('ll'), style: 'textoChico', alignment: 'left'}],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]
    
                    ]
                },
            },
            {
                style: 'tableExample',
                table: {
                    widths: ['100%'],
                    layout: {
                        defaultBorder: false,
                     },
                    body: [
                            [
                              {text: 'BALANZA DE COMPROBACIÓN', alignment: 'center', fontSize: 16, border: [false, false, false, false]}
                            ]
                       ]
                },
                            layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return {dash: {length: 2, space: 1}};
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return {dash: {length: 2}};
                    },
                }
                
            },
            {text: 'Datos de filtrado:'},
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                                        defaultBorder: false,
                                    },
                    
                    body: filtrados,
                },
                            layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return {dash: {length: 2, space: 1}};
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return {dash: {length: 2}};
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }
                
            },
            
            {
            table: {
                widths: ['15%', '30%', '10%', '15%', '15%', '15%'],
                layout: {
                    defaultBorder: true,
                },
                body: [
                    [
                        {text: 'Cuenta', style: 'tituloTabla'},
                        {text: 'Descripción', style: 'tituloTabla'},
                        {text: 'Saldo Inicial', style: 'tituloTabla'},
                        {text: 'Cargos', style: 'tituloTabla'},
                        {text: 'Abonos', style: 'tituloTabla'},
                        {text: 'Saldo Final', style: 'tituloTabla'},
                    ],
                    ...cuentasTable,
                ]
            },
            layout: {
                fillColor: (rowIndex, node, columnIndex) => {
                  return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
                },
                hLineWidth: function (i, node) {
                  return i === 0 || i === node.table.body.length ? 0 : 1;
                },
                vLineWidth: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? 0 : 1;
                },
                hLineColor: function (i, node) {
                  return "#adaaaa";
                },
                vLineColor: function (i, node) {
                  return "#adaaaa";
                },
                hLineStyle: function (i, node) {
                  if (i === 0 || i === node.table.body.length) {
                    return null;
                  }
                  return { dash: { length: 2, space: 1 } };
                },
                vLineStyle: function (i, node) {
                  if (i === 0 || i === node.table.widths.length) {
                    return null;
                  }
                  return { dash: { length: 2 } };
                },
              },            
            },
        ],
        images: {
            logo: empresa.logo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico:{
                fontSize: 7
            },
            tituloTabla:{
                fontSize: 8,
                bold: true, 
                fillColor: '#cccccc', 
                alignment: 'center',
            },
            tituloTabla1:{
                fontSize: 12,
                bold: true, 
                alignment: 'center',
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            },
            tituloCuentasMayor: {
                fontSize: 7,
                bold: true, 
                fillColor: '#E0E0E0', 
                alignment: 'center',
            },
            tituloCuentasMenor: {
                fontSize: 7,
                bold: true, 
                fillColor: '#F9F9F9', 
                alignment: 'center',
            },
        },
        pageSize: 'LETTER',
    }
  return dd;
};


export default reporteDeBalanzaDeComprobacionPdf;
